import { UserPermissionGrantDto } from './user-permissions.models';

function coerceBool(value: unknown): boolean {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'number') {
    return value !== 0;
  }
  if (typeof value === 'string') {
    const v = value.trim().toLowerCase();
    return v === 'true' || v === '1';
  }
  return !!value;
}

function normalizeGrantItem(item: unknown): UserPermissionGrantDto | null {
  if (!item || typeof item !== 'object') {
    return null;
  }
  const row = item as Record<string, unknown>;
  const permissionKey = String(
    row.permissionKey ?? row.PermissionKey ?? '',
  ).trim();
  if (!permissionKey) {
    return null;
  }
  return {
    permissionId: String(row.permissionId ?? row.PermissionId ?? ''),
    permissionKey,
    displayName: String(row.displayName ?? row.DisplayName ?? ''),
    read: coerceBool(row.read ?? row.Read),
    write: coerceBool(row.write ?? row.Write),
  };
}

/** BE camelCase / PascalCase / sarmalayıcı yanıtları tek forma çevirir */
export function extractPermissionGrantsFromResponse(
  response: unknown,
): UserPermissionGrantDto[] {
  if (!response || typeof response !== 'object') {
    return [];
  }
  const root = response as Record<string, unknown>;
  const candidates = [
    root.permissions,
    root.Permissions,
    (root.data as Record<string, unknown> | undefined)?.permissions,
    (root.data as Record<string, unknown> | undefined)?.Permissions,
    (root.result as Record<string, unknown> | undefined)?.permissions,
    (root.result as Record<string, unknown> | undefined)?.Permissions,
  ];

  const raw = candidates.find((item) => Array.isArray(item)) as
    | unknown[]
    | undefined;
  if (!raw?.length) {
    return [];
  }

  return raw
    .map((item) => normalizeGrantItem(item))
    .filter((item): item is UserPermissionGrantDto => !!item);
}
